import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import Selections from '../common/Selections';
import { WEBPUSH_TYPE_SELECTIONS } from '../../constants';
import { ButtonText } from '../styles/Button';
export const WebPushSubItem = ({ webpushSub, updateWebpushSub, deleteWebpushSub, }) => {
    const nameInputRef = useRef(null);
    const [editing, setEditing] = useState(false);
    const [nameInput, setNameInput] = useState('');
    const handleSelectAlarmType = (alarmType) => {
        const newWebpushSub = { ...webpushSub, alarmType };
        updateWebpushSub(newWebpushSub);
    };
    const handleDeleteWebpushSub = (auth) => {
        const confirm = window.confirm('Are you sure you want to delete this device from Mobile Alarm?');
        if (confirm) {
            deleteWebpushSub(auth);
        }
    };
    const onClickEdit = () => {
        setNameInput(webpushSub.deviceName);
        setEditing(!editing);
        setTimeout(() => {
            nameInputRef.current.focus();
        }, 100);
    };
    const onChangeName = (e) => {
        setNameInput(e.target.value);
    };
    const onBlurNameInput = () => {
        if (nameInput.trim() === '') {
            setEditing(false);
            return;
        }
        const newWebpushSub = { ...webpushSub, deviceName: nameInput };
        updateWebpushSub(newWebpushSub);
        setEditing(false);
    };
    return (React.createElement(WebPushSubItemWrapper, { key: webpushSub.auth },
        editing ? (React.createElement(Name, null,
            React.createElement(NameInput, { ref: nameInputRef, value: nameInput, onChange: onChangeName, onBlur: onBlurNameInput }))) : (React.createElement(Name, null,
            webpushSub.deviceName,
            ' ',
            React.createElement(EditButton, { onClick: onClickEdit },
                React.createElement(EditIcon, { src: "/icons/edit-black.png" })))),
        React.createElement(EditorSection, null,
            React.createElement(Selections, { idAttr: "id", selection: WEBPUSH_TYPE_SELECTIONS, selectedId: webpushSub.alarmType, textAttr: "text", fontSize: 14, width: 100, handleSelect: handleSelectAlarmType }),
            React.createElement(DeleteButton, { onClick: () => handleDeleteWebpushSub(webpushSub.auth) }, "x"))));
};
const WebPushSubItemWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const Name = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const EditorSection = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const DeleteButton = styled(ButtonText) `
  margin-left: 1rem;
`;
const EditButton = styled(ButtonText) `
  margin-left: 0.3rem;
`;
const EditIcon = styled.img `
  width: 0.9rem;
  opacity: 0.5;
`;
const NameInput = styled.input ``;
